// extracted by mini-css-extract-plugin
export default {"dlFileDownloadFormatter":"src-js-common-components-formatters-FileDownloadFormatter---dlFileDownloadFormatter---XbGSm"};